import { useEffect, useState, useMemo } from 'react';
import { FluxButton, FluxCircularProgress } from '@meltwater/flux-web-components-react';
import { Grid, Box, Button, Typography, Paper } from '@mui/material';
import Badge from '@mui/material/Badge';
import { MaterialReactTable } from 'material-react-table';
import { useParams } from 'react-router-dom';
import { SendGridService } from '../../services/sendgrid.service';
import Companycounts from './companyCounts';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from './sendgrid.module.css';
import SendgridResults from './sendgridresults';
import CompanyService from "../../services/company.services"
import { saveAs } from 'file-saver';

function getCountsByDay(data) {
  const companyData = [];
  const counts = {
    day1: 0,
    day2: 0,
    day3: 0,
    day4: 0,
    day5: 0,
    day6: 0,
    day7: 0,
    week2: 0,
    week3: 0,
    week4: 0,
    week5plus: 0
  };
  data.forEach(item => {
    const createdTime = new Date(item.created * 1000);
    const daysDifference = Math.floor((Date.now() - createdTime) / (1000 * 60 * 60 * 24));

    if (daysDifference >= 0 && daysDifference < 7) {
      counts[`day${daysDifference + 1}`]++;
    } else if (daysDifference >= 7 && daysDifference < 14) {
      counts.week2++;
    } else if (daysDifference >= 14 && daysDifference < 21) {
      counts.week3++;
    } else if (daysDifference >= 21 && daysDifference < 28) {
      counts.week4++;
    } else {
      counts.week5plus++;
    }
  });
  companyData.push({
    counts: counts
  });
  return companyData;
}

function SendGridCompany() {
  const [data, setData] = useState(null);
  const [companyName, setCompanyName] = useState('');
  const [useractivity, setUseractivity] = useState([]);
  const [blockactivity, setBlockactivity] = useState([]);
  const [bounceactivity, setBounceactivity] = useState([]);
  const [groupedblockactivity, setgroupedBlockactivity] = useState([]);
  const [groupedbounceactivity, setgroupedBounceactivity] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const { companyid } = useParams();
  
  const columns = useMemo(
    () => [
      {
        header: '',
        accessorKey: 'status',
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor:
                cell.getValue() === 'not_delivered'
                  ? theme.palette.error.dark
                  : theme.palette.success.dark,
              borderRadius: '1rem',
              color: '#fff',
              p: '1rem',
            })}
          >
          </Box>
        ),
        maxSize: 10,
        size: 10
      },
      {
        header: 'subject',
        accessorKey: 'subject', //simple accessorKey pointing to flat data
        grow: true,
        minSize: 250
      },
      {
        header: 'date',
        accessorKey: 'last_event_time', //simple accessorKey pointing to flat data
        accessorFn: (row) => {
          try {
            const date = new Date(row.last_event_time);
            return date.toLocaleString();
          } catch (e) {
            return row.last_event_time || 'N/A';
          }
        },
        maxSize: 150
      }
    ],
    [],
  );
  
  function getOneEmail(email) {
    return SendgridResults(email, bounceactivity.filter(item => item.email === email.to_email).slice(0, 15), blockactivity.filter(item => item.email === email.to_email).slice(0, 15));
  }
  
  const exportDetails = (rows) => {
    const content = `<html>
   <head>
     <style>
     table {
      border-collapse: collapse;
      width: 100%;
    }
    th, td {
      border: 1px solid #dddddd;
      text-align: left;
      font-size:80%;
      font-size: small,
      word-wrap: break-word; // Added property for vertical growth 
    }
    th {
      background-color: #188182; // Updated to match the teal color scheme
      color: white; // Set text color for header 
    }
     </style>
   </head>
   <Body>   
   ${rows.map((row) => {
      const title = `<h1>${row.original.subject}</h1>
    <hr/>`
      return title + getOneEmail(row.original)

    }).join('<hr/>')}   
   </Body>
   </html>
   `;
    // Add a header and a line break between each item
    // Create a Blob containing the text content
    const blob = new Blob([content], { type: 'application/msword' });
    // Save the Blob as a Word document
    const filename = `${companyName}-suppression-report.doc`
    saveAs(blob, filename);
  };
  
  useEffect(() => {
    async function fetchData() {
      setLoadingData(true);
      let myres;
      try {
        myres = await SendGridService.getcompanyActivityNewsletters(companyid)
        console.log("Useractivity ", myres.data.data.data.Blockdata.useractivity);
        setData(myres.data.data.data)
        setBlockactivity(myres.data.data.data.Blockdata.blocks)
        setBounceactivity(myres.data.data.data.Blockdata.bounces)
        setUseractivity(myres.data.data.data.Blockdata.useractivity)
        let bucketdata = getCountsByDay(myres.data.data.data.Blockdata.blocks)
        setgroupedBlockactivity(bucketdata);
        setgroupedBounceactivity(getCountsByDay(myres.data.data.data.Blockdata.bounces));
        setLoadingData(false);
      } catch (error) {
        console.log(`FAIL`, error);
        setLoadingData(false);
      }
    }
    fetchData();
  }, [companyid]);
  
  useEffect(() => {
    async function fetchData() {
      let myres;
      try {
        myres = await CompanyService.getCompany(companyid);
        if (myres.status === 'ok') {
          setCompanyName(myres.data.name);
        }
      } catch (error) {
        console.log(`FAIL`, error);
        // setCompanyId("");
      }
    }
    fetchData();
  }, [companyid]);
  
  async function repoll() {
    let myres = await SendGridService.repoll(companyid);
    if (myres.status ==='ok') {
      window.location.reload();
    }
  }
  
  // Determine if we should show the load more button based on the number of emails displayed
  const MAX_EMAIL_TABLES = 4;
  const [displayLimit, setDisplayLimit] = useState(MAX_EMAIL_TABLES);
  const hasMoreEmailsToShow = data?.trackedusers?.length > displayLimit;
  
  const handleLoadMore = () => {
    setDisplayLimit(prevLimit => prevLimit + MAX_EMAIL_TABLES);
  };
  
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.headerRow}>
          <Button 
            className={styles.backButton}
            onClick={() => window.history.back()}
            startIcon={<ArrowBackIcon />}
          >
            Back
          </Button>
          <Typography variant="h6" className={styles.tableHeader}>
            {companyName ? `${companyName} (${companyid}) - Suppression Status` : 'Loading Company Data...'}
          </Typography>
        </div>
      </div>
      
      <div className={styles.buttonRow}>
        <FluxButton type='filled' tint='primary' onClick={repoll}>
          Refresh Data
        </FluxButton>
      </div>
      
      {loadingData ? (
        <Grid container rowSpacing={1}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
              <FluxCircularProgress size={400} indeterminate>Gathering Company Information</FluxCircularProgress>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <>
          <div className={styles.chartContainer}>
            <Companycounts companyData={{ blocks: groupedblockactivity, bounces: groupedbounceactivity }} />
          </div>
          
          <Grid container spacing={3}>
            {data?.trackedusers?.slice(0, displayLimit).map((oneitem, idx) => {
              const myidex = useractivity.findIndex(innerArray => innerArray.some(item => item.to_email === oneitem));              
              const blocksexists = !blockactivity.some(obj => obj.email === oneitem);
              const blockcount = blockactivity.filter(item => item.email === oneitem).length;
              const bounceexists = !bounceactivity.some(obj => obj.email === oneitem);
              const bouncecount = bounceactivity.filter(item => item.email === oneitem).length;
              
              return (
                <Grid key={idx} item xs={12} md={6}>
                  <Paper className={styles.tableContainer}>
                    <Box sx={{ p: 2, borderBottom: '1px solid #e0e6e8' }}>
                      <Grid container alignItems="center">
                        <Grid item xs={7}>
                          <Typography variant="h6" sx={{ color: '#188182' }}>
                            Email Activity: {oneitem}
                          </Typography>
                        </Grid>
                        <Grid item xs={5} sx={{ textAlign: 'right' }}>
                          <Badge badgeContent={blockcount} color="warning" sx={{ mx: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-block',
                                padding: '6px 12px',
                                borderRadius: '16px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                backgroundColor: blocksexists ? '#e0e0e0' : '#f57c00',
                                color: blocksexists ? '#757575' : '#fff',
                              }}
                            >
                              Blocked
                            </Box>
                          </Badge>
                          <Badge badgeContent={bouncecount} color="error">
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-block',
                                padding: '6px 12px',
                                borderRadius: '16px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                backgroundColor: bounceexists ? '#e0e0e0' : '#d32f2f',
                                color: bounceexists ? '#757575' : '#fff',
                              }}
                            >
                              Bounce
                            </Box>
                          </Badge>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box sx={{ p: 2 }}>
                      <MaterialReactTable
                        columns={columns}
                        data={useractivity[myidex] || []}
                        enableRowSelection
                        enableColumnActions={false}
                        enableColumnFilters={false}
                        enableSelectAll
                        enableStickyHeader
                        layoutMode='grid'
                        enableGlobalFilter={false}
                        muiTablePaperProps={{ elevation: 0 }}
                        initialState={{ 
                          density: 'compact', 
                          columnVisibility: { Boolean: false, Language: false }, 
                          pagination: { pageSize: 5 } 
                        }}
                        renderTopToolbarCustomActions={({ table }) => (
                          <div key={table.row}>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: '#188182',
                                '&:hover': {
                                  backgroundColor: '#136e6f'
                                }
                              }}
                              onClick={() => exportDetails(table.getSelectedRowModel().rows)}
                              disabled={!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()}
                            >
                              Export Selected Writeup
                            </Button>
                          </div>
                        )}
                      />
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
            
            {hasMoreEmailsToShow && (
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 4 }}>
                  <Button 
                    variant="outlined" 
                    color="primary" 
                    onClick={handleLoadMore}
                  >
                    Load More Emails
                  </Button>
                </Box>
              </Grid>
            )}
            
            {data && data.trackedusers && data.trackedusers.length === 0 && (
              <Grid item xs={12}>
                <Paper className={styles.tableContainer}>
                  <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h6">No user activity found for this company</Typography>
                  </Box>
                </Paper>
              </Grid>
            )}
          </Grid>
        </>
      )}
    </div>
  );
}

export default SendGridCompany;